<div id="createReverseAuditWizard_createFromManual"  >
  <h1 class="title">Step 1 : Manually Build Reverse Audit</h1>
  <div class="titlebar-div">Build Rate audit for Reverse audit</div>
  <app-alert></app-alert>
  <div class="title">
    <div class="containingRow">
      <span class="inputContainer">
        <label class="labelContainer">Account ID <label class="asterix">*</label></label>

        <input
          autofocus
          type="text"
          [(ngModel)]="rateAudit.CustomerAccountID"
          (ngModelChange)="modelChange($event)" />
      </span>
      <span class="inputContainer">
        <label class="labelContainer">Account Name <label class="asterix">*</label></label>

        <input
          type="text"
          [(ngModel)]="rateAudit.CustomerAccountName"
          (ngModelChange)="modelChange($event)" />
      </span>
      <span class="inputContainer">
        <label class="labelContainer">RFP Contract Period</label>
        <!-- <input
          type="text"
          [(ngModel)]="rateAudit.ContractYear"
          (ngModelChange)="modelChange($event)" /> -->
          <kendo-dropdownlist [data]="contractYearList"
                              [(ngModel)]="contractYearhtml"
                              [valuePrimitive]="true"
                              [allowCustom]="false"
                              [popupSettings]="dropdownPopupSettings">
          </kendo-dropdownlist>

      </span>
    </div>
    <div class="containingRow">
      <label class="labelContainer">GDS Selection</label>
      <ngl-checkbox label="Amadeus">
        <input
          ngl
          type="checkbox"
          [(ngModel)]="rateAudit.auditAmadeus"
          (ngModelChange)="modelChange($event)" />
      </ngl-checkbox>
      <ngl-checkbox label="Apollo">
        <input
          ngl
          type="checkbox"
          [(ngModel)]="rateAudit.auditApollo"
          (ngModelChange)="modelChange($event)" />
      </ngl-checkbox>
      <ngl-checkbox label="Galileo">
        <input
          ngl
          type="checkbox"
          [(ngModel)]="rateAudit.auditGalileo"
          (ngModelChange)="modelChange($event)" />
      </ngl-checkbox>
      <ngl-checkbox label="Sabre">
        <input
          ngl
          type="checkbox"
          [(ngModel)]="rateAudit.auditSabre"
          (ngModelChange)="modelChange($event)" />
      </ngl-checkbox>
      <ngl-checkbox label="Worldspan">
        <input
          ngl
          type="checkbox"
          [(ngModel)]="rateAudit.auditWorldspan"
          (ngModelChange)="modelChange($event)" />
      </ngl-checkbox>
    </div>
    <div class="containingRow">
      <label class="labelContainer">Sabre PCC <label class="asterix" *ngIf="rateAudit.auditSabre">*</label></label>
      <input
        type="text"
        [disabled]="!rateAudit.auditSabre"
        [(ngModel)]="rateAudit.sabrePCC"
        (ngModelChange)="modelChange($event)" />
    </div>
    <div class="containingRow">
      <fieldset ngl-radio-group>
        <label class="labelContainer">Rate Access Type</label>
        <ngl-radio-option label="Corporate">
          <input
            ngl
            type="radio"
            [checked]="true"
            value="Corporate"
            [(ngModel)]="this.rateAudit.rateAccessType"
            (ngModelChange)="modelChange($event)" />
        </ngl-radio-option>
        <ngl-radio-option label="Negotiated">
          <input
            ngl
            type="radio"
            value="Negotiated"
            [(ngModel)]="this.rateAudit.rateAccessType"
            (ngModelChange)="modelChange($event)" />
        </ngl-radio-option>
        <ngl-radio-option label="Consortia">
          <input
            ngl
            type="radio"
            value="Consortia"
            [(ngModel)]="this.rateAudit.rateAccessType"
            (ngModelChange)="modelChange($event)" />
        </ngl-radio-option>
      </fieldset>
    </div>
    <div class="containingRow">
      <label class="labelContainer">Rate Access Code Filters </label>
      <input
        type="text"
        [(ngModel)]="rateAudit.RACFilters"
        (ngModelChange)="modelChange($event)" />
    </div>
</div>
<div class="titlebar-div">Properties in Program</div>
  <div class="title">
    <button class="slds-button cvt-primary" (click)="addNewProperty($event)">
      + Add New Record
    </button>
  </div>
  <div class="containingRowNoLeftPadding">
    <kendo-grid id="kendoGridPropertiesInProgram"
      [data]="gridView"
      [pageSize]="state.take"
      [skip]="state.skip"
      [sort]="state.sort"
      [sortable]="true"
      [pageable]="true"
      [scrollable]="'scrollable'"
      (dataStateChange)="dataStateChange($event)">
      <kendo-grid-column field="PropertyName" title="Delete" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a href="#" (click)="clickDelete($event, dataItem)" class="deleteLink">
            <span title="Delete property" class="cvt-icon-trash grid-cmd-icons"></span>
          </a>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="errorRow" title="" [width]="40">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span title="Missing data in required fields " *ngIf="dataItem.errorRow" class="cvt-icon-error grid-cmd-icons erroricon"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyName" title="Property" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <label class="asterix">*</label>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='PropertyName'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.PropertyName"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='PropertyName'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'PropertyName')"
              class="propertyValueDiv">
              {{dataItem.PropertyName}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyAddress" title="Address" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='PropertyAddress'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.PropertyAddress"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='PropertyAddress'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'PropertyAddress')"
              class="propertyValueDiv">
              {{dataItem.PropertyAddress}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyCity" title="City" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='PropertyCity'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.PropertyCity"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='PropertyCity'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'PropertyCity')"
              class="propertyValueDiv">
              {{dataItem.PropertyCity}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyStateProvince" title="State/Province" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='PropertyStateProvince'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.PropertyStateProvince"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='PropertyStateProvince'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'PropertyStateProvince')"
              class="propertyValueDiv">
              {{dataItem.PropertyStateProvince}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyPostalCode" title="Postal Code" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='PropertyPostalCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.PropertyPostalCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='PropertyPostalCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'PropertyPostalCode')"
              class="propertyValueDiv">
              {{dataItem.PropertyPostalCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PropertyCountry" title="Country" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='PropertyCountry'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.PropertyCountry"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='PropertyCountry'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'PropertyCountry')"
              class="propertyValueDiv">
              {{dataItem.PropertyCountry}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="hotelChainCode" title="Hotel Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <label class="asterix">*</label>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='hotelChainCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.hotelChainCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='hotelChainCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'hotelChainCode')"
              class="propertyValueDiv">
              {{dataItem.hotelChainCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="AmadeusChainCode" title="Amadeus Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditAmadeus"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='AmadeusChainCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.AmadeusChainCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='AmadeusChainCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'AmadeusChainCode')"
              class="propertyValueDiv">
              {{dataItem.AmadeusChainCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="amadeusPropCode" title="Amadeus Prop Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditAmadeus"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='amadeusPropCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.amadeusPropCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='amadeusPropCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'amadeusPropCode')"
              class="propertyValueDiv">
              {{dataItem.amadeusPropCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="amadeusRAC" title="Amadeus RAC" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditAmadeus"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='amadeusRAC'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.amadeusRAC"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='amadeusRAC'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'amadeusRAC')"
              class="propertyValueDiv">
              {{dataItem.amadeusRAC}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="ApolloChainCode" title="Apollo Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditApollo"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='ApolloChainCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.ApolloChainCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='ApolloChainCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'ApolloChainCode')"
              class="propertyValueDiv">
              {{dataItem.ApolloChainCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="apolloPropCode" title="Apollo Prop Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditApollo"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='apolloPropCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.apolloPropCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='apolloPropCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'apolloPropCode')"
              class="propertyValueDiv">
              {{dataItem.apolloPropCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="apolloRAC" title="Apollo RAC" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditApollo"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='apolloRAC'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.apolloRAC"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='apolloRAC'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'apolloRAC')"
              class="propertyValueDiv">
              {{dataItem.apolloRAC}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="GalileoChainCode" title="Galileo Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditGalileo"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='GalileoChainCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.GalileoChainCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='GalileoChainCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'GalileoChainCode')"
              class="propertyValueDiv">
              {{dataItem.GalileoChainCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="galileoPropCode" title="Galileo Prop Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditGalileo"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='galileoPropCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.galileoPropCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='galileoPropCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'galileoPropCode')"
              class="propertyValueDiv">
              {{dataItem.galileoPropCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="galileoRAC" title="Galileo RAC" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditGalileo"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='galileoRAC'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.galileoRAC"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='galileoRAC'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'galileoRAC')"
              class="propertyValueDiv">
              {{dataItem.galileoRAC}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="SabreChainCode" title="Sabre Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditSabre"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='SabreChainCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.SabreChainCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='SabreChainCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'SabreChainCode')"
              class="propertyValueDiv">
              {{dataItem.SabreChainCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="sabrePropCode" title="Sabre Prop Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditSabre"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='sabrePropCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.sabrePropCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='sabrePropCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'sabrePropCode')"
              class="propertyValueDiv">
              {{dataItem.sabrePropCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="sabreRAC" title="Sabre RAC" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditSabre"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='sabreRAC'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.sabreRAC"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='sabreRAC'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'sabreRAC')"
              class="propertyValueDiv">
              {{dataItem.sabreRAC}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="WorldspanChainCode" title="Worldspan Chain Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditWorldspan"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='WorldspanChainCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.WorldspanChainCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='WorldspanChainCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'WorldspanChainCode')"
              class="propertyValueDiv">
              {{dataItem.WorldspanChainCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="worldspanPropCode" title="Worldspan Prop Code" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditWorldspan"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='worldspanPropCode'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.worldspanPropCode"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='worldspanPropCode'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'worldspanPropCode')"
              class="propertyValueDiv">
              {{dataItem.worldspanPropCode}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="worldspanRAC" title="Worldspan RAC" [width]="200">
          <ng-template kendoGridHeaderTemplate  let-column>
              <span >{{column.title}}</span> <span *ngIf="rateAudit.auditWorldspan"><label class="asterix">*</label></span>
          </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="currentlyEditingItem==dataItem && currentlyEditingValue=='worldspanRAC'">
            <input
              #editPropertyValueTextBox
              class="editPropertyValueTextBox"
              tabindex="-1"
              type="text"
              [(ngModel)]="dataItem.worldspanRAC"
              (ngModelChange)="modelChange($event)"/>
          </ng-container>
          <ng-container *ngIf="currentlyEditingItem!=dataItem || currentlyEditingValue!='worldspanRAC'">
            <div
              (click)="setCurrentlyEditingItem($event, dataItem, 'worldspanRAC')"
              class="propertyValueDiv">
              {{dataItem.worldspanRAC}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
